import { queryOptions, useQuery } from "@tanstack/react-query"
import { personalityKeys } from "../model/keys"
import { extractPersonalityProfile } from "../model/profile"
import { getFriendPersonality, getUserPersonality } from "./client"

export function personalityQueryOptions(userId: number) {
	return queryOptions({
		queryKey: personalityKeys.byUserId(userId),
		queryFn: () => getUserPersonality(userId),
		staleTime: 60_000,
	})
}

export function usePersonality(userId: number) {
	return useQuery({
		...personalityQueryOptions(userId),
		select: (data) => extractPersonalityProfile(data),
	})
}

export function useFriendPersonality(friendId: number) {
	return useQuery({
		queryKey: personalityKeys.byFriendId(friendId),
		queryFn: () => getFriendPersonality(friendId),
		staleTime: 60_000,
		select: (data) => extractPersonalityProfile(data),
	})
}
